import type React from "react";
import { useState } from "react";

import { type SelectProps, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { BaseButton } from "shared/atoms/BaseButton";
import { MUIDropdown } from "shared/atoms/inputs";
import { MUIUnifiedModal } from "shared/atoms/MUIUnifiedModal";
import { AnalyticsEvents, AnalyticsService } from "utils/analytics";

interface Props {
  setOpen: (open: boolean) => void;
  patientId?: number;
}
export const DropInCallFeedbackPopup: React.FC<Props> = ({ setOpen, patientId }) => {
  const { t } = useTranslation();
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [answer, setAnswer] = useState<unknown>(null);
  const options = [
    { label: t("drop_in_calls.feedback_popup.option_1"), value: "1", disabled: true },
    { label: t("drop_in_calls.feedback_popup.option_2"), value: "2" },
    { label: t("drop_in_calls.feedback_popup.option_3"), value: "3" },
    { label: t("drop_in_calls.feedback_popup.option_4"), value: "4" },
    { label: t("drop_in_calls.feedback_popup.option_5"), value: "5" },
  ];
  const onChange = (event: Parameters<NonNullable<SelectProps["onChange"]>>[0]) => {
    const index = options.findIndex(obj => obj.value === event.target.value);
    if (index > 0) {
      setAnswer(event.target.value);
      setButtonDisabled(false);
    }
  };

  const onSubmit = () => {
    if (answer) {
      AnalyticsService.track(AnalyticsEvents.DROP_IN_CALLS.FEEDBACK_ANSWER, {
        answer,
        patient: patientId,
      });
      setOpen(false);
    }
  };
  return (
    <MUIUnifiedModal open onClose={() => setOpen(false)} title={t("drop_in_calls.feedback_popup.title")} width="400px">
      <Stack p={2} spacing={2} alignItems="center">
        <Typography>{t("drop_in_calls.feedback_popup.body")}</Typography>
        <StyledMUIDropdown in_form={false} name="dropincall-feedback-dropdown" options={options} onChange={onChange} />
        <BaseButton disabled={buttonDisabled} onClick={onSubmit}>
          {t("drop_in_calls.end_call")}
        </BaseButton>
      </Stack>
    </MUIUnifiedModal>
  );
};

const StyledMUIDropdown = styled(MUIDropdown)`
  .MuiInputBase-root {
    .MuiSelect-select {
      padding: 12px;
    }
  }
`;
